import {ParagraphText} from '@thryvlabs/maverick'
import React, {useState, useEffect} from 'react'
import {getRemainingTimeFromMS} from '../utils/get-remaining-time-from-ms'
import {Modal} from '@thryvlabs/maverick'
import {useAuthClient} from '../utils/use-auth-client'
import {toast} from 'react-toastify'

function CountdownTimer({
  countdownTimeMS,
  creativeApptId,
  thryvSuccessServicesApptId,
  kickoffApptId,
  countryIsoValue,
  setKickoffApptId,
  setCreativeApptId,
  setThryvSuccessServicesApptId,
  prevStep,
  setCreativeCallDate,
  setThryvSuccessServicesCallDate,
  setOnboardingCallDate,
  frontendCcPaymentDetails,
  updateApptOnExpire,
  onExpire,
  isHourlyNeeded = false,
}) {
  const defaultRemainingTime = {
    hours: '23',
    minutes: '59',
    seconds: '59',
  }
  if (isHourlyNeeded) {
    defaultRemainingTime.hours = Number(countdownTimeMS) / 60 - 1
    defaultRemainingTime.minutes = 59
    defaultRemainingTime.seconds = 59
  } else {
    defaultRemainingTime.hours = 0
    defaultRemainingTime.minutes =
      countdownTimeMS === 60 ? 59 : 60 - countdownTimeMS - 1
    defaultRemainingTime.seconds = 59
  }

  const [remainingTime, setRemainingTime] = useState(defaultRemainingTime)
  const client = useAuthClient()
  const cancelDemo = React.useCallback(async () => {
    const creativeData = {
      type: 'creative',
      country: countryIsoValue,
      demoApptId: creativeApptId,
    }
    const kickoffData = {
      type: 'onboarding',
      country: countryIsoValue,
      demoApptId: kickoffApptId,
    }
    const thryvSuccessServicesData = {
      type: 'thryv-success-services',
      country: countryIsoValue,
      demoApptId: thryvSuccessServicesApptId,
    }
    try {
      onExpire?.()
      if (creativeApptId) {
        client(`plans/creative`, {
          data: {...creativeData},
          method: 'DELETE',
        })
        updateApptOnExpire('creative', creativeApptId)
      }
      if (kickoffApptId) {
        client(`plans/onboarding`, {
          data: {...kickoffData},
          method: 'DELETE',
        })
        updateApptOnExpire('onboarding', kickoffApptId)
      }
      if (thryvSuccessServicesApptId) {
        client(`plans/thryv-success-services`, {
          data: {...thryvSuccessServicesData},
          method: 'DELETE',
        })
        updateApptOnExpire('thryv-success-services', thryvSuccessServicesApptId)
      }
      setCreativeApptId(null)
      setThryvSuccessServicesApptId(null)
      setKickoffApptId(null)
      setCreativeCallDate(null)
      setThryvSuccessServicesCallDate(null)
      setOnboardingCallDate(null)
    } catch (e) {
      toast.warn('There was a problem with the cancellation')
    }
  }, [
    client,
    countryIsoValue,
    creativeApptId,
    kickoffApptId,
    thryvSuccessServicesApptId,
    setCreativeApptId,
    setThryvSuccessServicesApptId,
    setCreativeCallDate,
    setThryvSuccessServicesCallDate,
    setKickoffApptId,
    setOnboardingCallDate,
  ])
  useEffect(() => {
    if (
      Number(remainingTime.hours) * 3600 +
        Number(remainingTime.seconds) +
        Number(remainingTime.minutes) * 60 >=
      1
    ) {
      const intervalId = setInterval(() => {
        updateTime(countdownTimeMS)
      }, 1000)
      return () => clearTimeout(intervalId)
    } else {
      cancelDemo()
    }
  }, [
    cancelDemo,
    client,
    countdownTimeMS,
    countryIsoValue,
    creativeApptId,
    kickoffApptId,
    thryvSuccessServicesApptId,
    remainingTime.minutes,
    remainingTime.seconds,
    remainingTime.hours,
    setCreativeApptId,
    setThryvSuccessServicesApptId,
    setKickoffApptId,
  ])

  useEffect(() => {
    window.addEventListener('beforeunload', ev => {
      ev.preventDefault()
      return (ev.returnValue = 'Are you sure you want to close?')
    })
  }, [])

  function updateTime(countdown) {
    setRemainingTime(getRemainingTimeFromMS(countdown))
  }
  return Number(remainingTime.hours) +
    Number(remainingTime.seconds) +
    Number(remainingTime.minutes) * 60 >
    0 ? (
    <>
      <ParagraphText
        variant={'reg'}
        color={'thryv-orange-500'}
        className={`font-weight-bold ${
          frontendCcPaymentDetails ? 'm-0' : 'mt-2'
        }`}
      >
        <span style={{color: frontendCcPaymentDetails ? '#FF5000' : 'gray'}}>
          Appointment(s){' '}
        </span>{' '}
        Expire in:{' '}
        {isHourlyNeeded ? (
          <span style={{fontSize: '16px'}}>
            {remainingTime.hours}:{remainingTime.minutes}:
            {remainingTime.seconds}
          </span>
        ) : (
          <span style={{fontSize: '16px'}}>
            {remainingTime.minutes}:{remainingTime.seconds}
          </span>
        )}
      </ParagraphText>
    </>
  ) : (
    <Modal
      variant="default"
      title="Scheduled Appointments"
      btnType="form"
      disableBackdropClick
      footer
      action
      hideX
      btnActionText="OK"
      btnAction={() => prevStep()}
      width={'700px'}
      openOnLoad
    >
      <ParagraphText
        className="text-center"
        color={'thryv-neutral'}
        variant="reg"
      >
        Your appointments have expired. Please reschedule.
      </ParagraphText>
    </Modal>
  )
}

export default CountdownTimer
